// frontend/src/pages/PaymentCanceled.tsx

import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import '../styles/PaymentPages.css';

/**
 * Payment Canceled Page
 * Displayed when user cancels Stripe Checkout
 */
export const PaymentCanceled: React.FC = () => {
  const navigate = useNavigate();

  useEffect(() => {
    document.title = 'Payment Canceled - AIPrep';
  }, []);

  const handleRetry = () => {
    // Navigate back to home where they can try upgrading again
    navigate('/');
  };

  return (
    <div className="payment-page">
      <div className="payment-card canceled">
        <div className="icon-container">
          <svg className="canceled-icon" viewBox="0 0 24 24" aria-hidden="true">
            <circle cx="12" cy="12" r="11" fill="#f59e0b" />
            <path
              d="M8 8l8 8M16 8l-8 8"
              stroke="white"
              strokeWidth="2"
              strokeLinecap="round"
            />
          </svg>
        </div>

        <h1 className="payment-title">Payment Canceled</h1>

        <p className="payment-message">
          No charges were made to your account. You can upgrade to Pro anytime.
        </p>

        <div className="benefits-reminder">
          <h2 className="benefits-title">Pro Benefits You're Missing:</h2>
          <ul className="features-list">
            <li>10,000 AI helps per month</li>
            <li>Solution verification</li>
            <li>AI tutor chat</li>
            <li>Algorithm animations</li>
            <li>Document extraction</li>
            <li>Collection generation</li>
          </ul>
          <p className="promo-reminder">
            <strong>Limited Time:</strong> 70% off - Only $29.99/month (Regular price: $99.00)
          </p>
        </div>

        <div className="action-buttons">
          <button
            className="retry-button"
            onClick={handleRetry}
            aria-label="Try upgrading again"
          >
            Try Again
          </button>
          <button
            className="continue-free-button"
            onClick={() => navigate('/')}
            aria-label="Continue with free plan"
          >
            Continue with Free Plan
          </button>
        </div>

        <p className="support-text">
          Have questions? Contact our support team at support@aiprep.com
        </p>
      </div>
    </div>
  );
};
